// Containers
import ProductContainer from "./containers/ProductContainer";

export default [
    {
        path: "/:category/:subcategory/:product/",
        component: ProductContainer
    }
];